<template>
  <div>
  <panel class="pt-6 mt-8">
  <div class="flex flex-wrap -mx-3">
    <div class="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
      <label class="text-grey-darker mb-1 block">Search</label>
      <input type="text" v-model="searchParams.q" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3" />
    </div>
    <div class="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
      <label>Office:</label>
      <select
        v-model="searchParams.office_id"
        class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm">
        <option :value="null">All Offices</option>
        <option v-for="office in offices" :key="office.id" :value="office.id">{{ office.name }} ({{ office.address_town }})</option>
      </select>
    </div>
  </div>
  <hr class="border-b border-grey-darker w-full mb-6" />
  <loader v-if="loading" />
  <div v-else-if="userList.data.length === 0">
    No staff found.
  </div>
  <div v-else>
    <table class="w-full">
      <thead class="uppercase text-xs">
        <th class="text-left">Full Name</th>
        <th class="text-left">Branch Name</th>
        <th class="text-left">Job Title</th>
        <th class="text-left">Mobile</th>
        <th class="text-left">Email Address</th>
      </thead>
      <tbody class="text-sm">
        <tr v-for="user in userList.data" :key="user.id" class="border-t border-grey-lighter hover:bg-grey-lightest cursor-pointer">
          <td class="text-left">{{user.name}}</td>
          <td class="text-left"><pop-over-staff-directory :userAssociatedText="user.offices" :popUpUser="user"></pop-over-staff-directory></td>
          <td class="text-left">{{user.position}}</td>
          <td class="text-left">{{user.mobile}}</td>
          <td class="text-left">{{user.email}}</td>
        </tr>
      </tbody>
    </table>
    <paginator :data="userList" @change="page"/>
  </div>
</panel>
</div>
</template>

<script>
import api, { v2Api } from '@/http'
import { mapState } from 'vuex'
import debounce from 'lodash/debounce'
import PopOverStaffDirectory from '../../components/Profiles/PopOverStaffDirectory.vue'
export default {
  components: {
    PopOverStaffDirectory
  },
  data () {
    return {
      searchParams: {
        page: 1,
        q: '',
        office_id: null
      },
      userList: [],
      loading: true,
      offices: []
    }
  },
  computed: {
    ...mapState(['selectedOffice'])
  },
  watch: {
    searchParams: {
      handler () {
        this.search()
      },
      deep: true
    }
  },
  created () {
    this.getOfficeList()
    this.search()
  },
  methods: {
    search: debounce(function () {
      this.loading = true
      api.get('/flock-directory', {
        params: this.searchParams
      }).then((response) => {
        this.userList = response.data
        this.loading = false
      })
    }, 500),
    page (i) {
      this.searchParams.page = i
      this.search()
    },
    getOfficeList () {
      v2Api.get('office', {
        params: {
          network_id: this.selectedOffice.network_id,
          all: 1,
          management: true
        }
      }).then((response) => {
        this.offices = response.data
      })
    }
  }
}
</script>
<style lang="sass" scoped>
table
  @apply table-auto w-full
  thead
    @apply border-b uppercase text-xs
    th
      @apply pb-2 font-semibold
  tbody
    @apply text-sm capitalize
    tr
      @apply border-b
      td
        @apply py-4 align-middle
.recruitment-section
  @apply mt-4 p-6 rounded-lg bg-white
.recruitment-button
  @apply mr-4 py-2 px-6 rounded
  transition: background .5s
  &--small
    @apply text-sm px-4
</style>
